import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {IndexComponent} from './pages/index/index.component';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {LoginComponent} from './pages/login/login.component';
import {AuthenticationService} from './services/authentication.service';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {AuthGuard} from './authguard/auth.guard';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {MomentModule} from 'ngx-moment';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {SystemUserService} from './services/system-user.service';
import {BrandService} from './services/brand.service';
import {CategoryService} from './services/category.service';
import {SapCategoryService} from './services/sap-category.service';
import {ProductService} from './services/product.service';
import {PartnerService} from './services/partner.service';
import {DiscountService} from './services/discount.service';
import {AddOnService} from './services/add-on.service';
import {SystemUserListingComponent} from './pages/system-user/system-user-list/system-user-list.component';
import {ToastrModule} from 'ngx-toastr';
import {SystemUserDetailComponent} from './pages/system-user/system-user-detail/system-user-detail.component';
import {SystemUserAddComponent} from './pages/system-user/system-user-add/system-user-add.component';
import {SystemUserEditComponent} from './pages/system-user/system-user-edit/system-user-edit.component';
import { BrandsListComponent } from './pages/ecomm/brands/brands-list.component';
import { BrandsAddComponent } from './pages/ecomm/brands/brands-add.component';
import { BrandsDetailComponent } from './pages/ecomm/brands/brands-detail.component';
import { CategoriesListComponent } from './pages/ecomm/categories/categories-list.component';
import { CategoriesAddComponent } from './pages/ecomm/categories/categories-add.component';
import { CategoriesDetailComponent } from './pages/ecomm/categories/categories-detail.component';
import { SapCategoriesListComponent } from './pages/ecomm/sap-categories/sap-categories-list.component';
import { SapCategoriesAddComponent } from './pages/ecomm/sap-categories/sap-categories-add.component';
import { SapCategoriesDetailComponent } from './pages/ecomm/sap-categories/sap-categories-detail.component';
import { ProductsListComponent } from './pages/ecomm/products/products-list.component';
import { ProductsAddComponent } from './pages/ecomm/products/products-add.component';
import { ProductsDetailComponent } from './pages/ecomm/products/products-detail.component';
import { DiscountsListComponent } from './pages/ecomm/discounts/discounts-list.component';
import { DiscountsAddComponent } from './pages/ecomm/discounts/discounts-add.component';
import { DiscountsDetailComponent } from './pages/ecomm/discounts/discounts-detail.component';
import { CorporateDealsListComponent } from './pages/ecomm/corporate-deals/corporate-deals-list.component';
import { CorporateDealsAddComponent } from './pages/ecomm/corporate-deals/corporate-deals-add.component';
import { CorporateDealsDetailComponent } from './pages/ecomm/corporate-deals/corporate-deals-detail.component';
import { AddOnsListComponent } from './pages/ecomm/add-ons/add-ons-list.component';
import { AddOnsAddComponent } from './pages/ecomm/add-ons/add-ons-add.component';
import { AddOnsDetailComponent } from './pages/ecomm/add-ons/add-ons-detail.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpInterceptorService } from './services/http-interceptor.service';
import { provideTranslateService } from '@ngx-translate/core';
import { BadgeStatusComponent } from './shared/components/badge/status/badge-status.component';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    DashboardComponent,
    LoginComponent,
    SystemUserListingComponent,
    SystemUserDetailComponent,
    SystemUserAddComponent,
    SystemUserEditComponent,
    BrandsListComponent,
    BrandsAddComponent,
    BrandsDetailComponent,
    CategoriesListComponent,
    CategoriesAddComponent,
    CategoriesDetailComponent,
    SapCategoriesListComponent,
    SapCategoriesAddComponent,
    SapCategoriesDetailComponent,
    ProductsListComponent,
    ProductsAddComponent,
    ProductsDetailComponent,
    DiscountsListComponent,
    DiscountsAddComponent,
    DiscountsDetailComponent,
    CorporateDealsListComponent,
    CorporateDealsAddComponent,
    CorporateDealsDetailComponent,
    AddOnsListComponent,
    AddOnsAddComponent,
    AddOnsDetailComponent,
  ],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    MomentModule,
    NgxDaterangepickerMd.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    BadgeStatusComponent,
  ],
  providers: [
    AuthenticationService,
    SystemUserService,
    BrandService,
    CategoryService,
    SapCategoryService,
    ProductService,
    PartnerService,
    DiscountService,
    AddOnService,
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    AuthGuard,
    provideTranslateService()],
  bootstrap: [AppComponent]
})
export class AppModule {}
